module.exports = __webpack_public_path__ + "img/1.71fab105.jpg";